/**
 * Format a price for display in the UI
 * 
 * IMPORTANT: All monetary values in this codebase are stored in ØRE (1/100 of a krone)
 * This function converts from øre to kroner for display purposes.
 * 
 * @param {number} priceInOre - The price in øre (e.g., 16900 for 169 kr)
 * @returns {string} Formatted price string (e.g., "169,-")
 */
export function formatPrice(priceInOre) {
  const kroner = Math.round(priceInOre / 100)
  return `${kroner},-`
}

/**
 * Format a price with decimals (if needed)
 * Converts from øre to kroner
 * 
 * @param {number} priceInOre - The price in øre
 * @returns {string} Formatted price string
 */
export function formatPriceWithDecimals(priceInOre) {
  const kroner = priceInOre / 100
  // Only show decimals if there are øre
  if (priceInOre % 100 === 0) {
    return `${kroner.toFixed(0)},-`
  }
  return `${kroner.toFixed(2).replace('.', ',')} kr`
}

/**
 * Convert kroner to øre
 * Use this when receiving external input in kroner
 * 
 * @param {number} kroner - The price in kroner
 * @returns {number} The price in øre
 */
export function kronerToOre(kroner) {
  return Math.round(kroner * 100)
}

/**
 * Convert øre to kroner
 * Use this when you need the raw number (not formatted string)
 * 
 * @param {number} ore - The price in øre
 * @returns {number} The price in kroner
 */
export function oreToKroner(ore) {
  return ore / 100
}
